import { render, staticRenderFns } from "./PageBlocksList.vue?vue&type=template&id=acdbd908&"
import script from "./PageBlocksList.vue?vue&type=script&lang=js&"
export * from "./PageBlocksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports